import { Link } from '@material-ui/core';
import React from 'react';
import { ProjectKeywordGq } from '../../../../../../graphql/projects/models/ProjectKeywordGq';
import { SerpStatusGq } from '../../../../../../graphql/projects/models/SerpStatusGq';
import VoxelLoadingSpinner from '../../../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelDataTableCell from '../../../../../voxel/DataTable/VoxelDataTableCell';
import VoxelTooltipShort from '../../../../../voxel/Tooltip/VoxelTooltipShort';
import VoxelLink from '../../../../../voxel/Link/VoxelLink';

export interface TableCellRankingUrlProps {
  url?: string;
  keyword: ProjectKeywordGq;
  domain?: string;
  borderRight?: boolean;
  serpStatus?: SerpStatusGq;
}

const TableCellRankingUrl: React.FC<TableCellRankingUrlProps> = ({
  url,
  domain,
  borderRight,
  serpStatus,
  keyword,
}) => {
  if (!keyword.serpResultTime)
    return (
      <VoxelDataTableCell align={'left'} className={`${borderRight && 'border-r'}`}>
        <div className="w-full flex flex-row justify-start">
          {serpStatus === SerpStatusGq.PROCESSING && <VoxelLoadingSpinner />}
        </div>
      </VoxelDataTableCell>
    );
  if (!url) return <VoxelDataTableCell className={`${borderRight && 'border-r'}`} />;

  let modifiedUrl: string = undefined;

  if (domain) {
    const urlIndex = url?.indexOf(domain);
    if (urlIndex > -1) {
      modifiedUrl = url.slice(urlIndex + domain.length);
    } else {
      modifiedUrl = url;
    }
  }

  return (
    <VoxelDataTableCell
      align={'left'}
      className={`max-w-xs truncate flex-nowrap ${borderRight && 'border-r'}`}
    >
      <VoxelTooltipShort message={url} placement="top">
        <VoxelLink
          onMouseDown={(event: React.MouseEvent<any>) => {
            event.stopPropagation();
          }}
          href={url}
          rel="noreferrer"
          target="_blank"
          className="!text-voxel-gray-600"
        >
          {modifiedUrl}
        </VoxelLink>
      </VoxelTooltipShort>
    </VoxelDataTableCell>
  );
};

export default TableCellRankingUrl;
